import { useState } from "react";
import { useApi, apiPost } from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { LoadingBlock, ErrorState } from "@/components/common/StateViews";
import { SeverityChip } from "@/components/common/SeverityChip";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { fmtDate } from "@/lib/format";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function Requests() {
  const { data: reqs = [], isLoading, error, refetch } = useApi("requests", "/requests");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ tool: "", reason: "" });
  const create = async () => { if (!form.tool) return toast.error("Tool required"); await apiPost("/requests", form); toast.success("Request submitted — routed to your manager"); setOpen(false); setForm({ tool: "", reason: "" }); refetch(); };
  if (error) return <ErrorState />;

  return (
    <div>
      <PageHeader eyebrow="Navitra Companion" title="Requests" subtitle="Request access to AI tools or policy exceptions. Approvals happen in Teams; access is time-boxed.">
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button size="sm" data-testid="new-request"><Plus className="h-4 w-4 mr-1.5" />New request</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle className="font-display">Request AI tool access</DialogTitle></DialogHeader>
            <div className="space-y-4 py-2">
              <div><Label>Tool</Label><Input value={form.tool} onChange={(e) => setForm({ ...form, tool: e.target.value })} placeholder="e.g. Claude Enterprise" data-testid="req-tool" /></div>
              <div><Label>Business reason</Label><Textarea value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} placeholder="Why do you need this?" data-testid="req-reason" /></div>
            </div>
            <DialogFooter><Button onClick={create} data-testid="submit-request">Submit</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </PageHeader>
      {isLoading ? <LoadingBlock /> : (
        <Card><CardContent className="p-0">
          <Table>
            <TableHeader><TableRow><TableHead>Tool</TableHead><TableHead>Reason</TableHead><TableHead>Status</TableHead><TableHead>Approver</TableHead><TableHead>Expiry</TableHead></TableRow></TableHeader>
            <TableBody>{reqs.map((r) => (
              <TableRow key={r.id} data-testid={`req-row-${r.id}`}><TableCell className="font-medium">{r.tool}</TableCell><TableCell className="text-sm text-muted-foreground max-w-xs">{r.reason}</TableCell><TableCell><SeverityChip level={r.status} /></TableCell><TableCell className="text-sm text-muted-foreground">{r.approver}</TableCell><TableCell className="text-sm">{r.expiry ? fmtDate(r.expiry) : "—"}</TableCell></TableRow>
            ))}</TableBody>
          </Table>
        </CardContent></Card>
      )}
    </div>
  );
}
